import type { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import Tooltip from '@/components/Tooltip';
import { classes } from './utils';

export interface OptionButtonProps extends PropsWithChildren {
  className?: string;
  title?: string;
  onClick: () => void;
}

export default function OptionButton({
  className,
  title,
  children,
  onClick,
}: OptionButtonProps) {
  const button = (
    <button
      className={twMerge(classes.iconButton, className)}
      onClick={onClick}>
      {children}
    </button>
  );
  return title ? (
    <Tooltip arrow title={title}>
      {button}
    </Tooltip>
  ) : (
    button
  );
}
